<style lang="less" scoped>
    .container {
        position: relative;
        min-height: 300px;
        /deep/ .expense-type-line {
            &:hover {
                background-color: #f5f5f5;
            }
        }
        /deep/ .bill-type{
            display: inline-block;
            margin-right: 10px;
        }
        /deep/ .ivu-tree-title{
            width: 100%;
        }
    }
    table{
        border-collapse:collapse;
        border: 1px solid #dddee1;
    }
    table tr{
        border-bottom: 1px solid #dddee1;
    }
    table th, table td{
        border-right: 1px solid #dddee1;
        padding: 5px 10px;
    }
    .pop-tip-text{
        display: inline-block;
        width: 100%;
        cursor: pointer;
    }
    .pop-tip-text:hover{
        font-weight: bold;
    }
    .pop-tip-content{
        text-align: center;
    }
</style>
<template>
  <div class="container">
    <Tree
      :data="cash_flow_types_tree_data"
      :render="renderContent"
      children-key="cash_flow_types"
    />
    <Spin
      v-if="loading"
      fix
    />
    <Modal
      v-model="config.modal"
      title="添加 / 编辑"
      :loading="config.loading"
      @on-ok="editOk"
    >
      <div class="line">
        <div class="line">
          <span style="margin-left: 100px" />
          <span>[ 级别: {{ edit_cash_flow_type.level }} ] </span>
          <span>[ 父级: {{ getParentTypeName(edit_cash_flow_type.parent_id) }} ]</span>
        </div>
        <Form
          :model="edit_cash_flow_type"
          :label-width="100"
        >
          <Form-item label="名称">
            <i-input
              v-model="edit_cash_flow_type.name"
              placeholder="请输入"
            />
          </Form-item>
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script route="/fin/cash_flow_type">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/fin/cash_flow_type',
    /* router_info_end */
    data() {
      return {
        loading: false,
        cash_flow_types: [],
        cash_flow_type_hash: {},
        cash_flow_type_trs: [],
        edit_cash_flow_type: {},
        new_cash_flow_type: {
          name: '',
          level: 1,
          parent_id: 0,
        },
        config: {modal: false, loading: true},
        fake_id: 0,
        final_cash_flow_types: [],
        fin_cash_flow_types: []
      }
    },
    computed: {
      col_len() {
        let max = 0;
        this.cash_flow_type_trs.forEach((tds) => {
          tds.forEach((td) => {
            if (td.level && td.level > max) {
              max = td.level;
            }
          });
        });
        return max;
      },
      cash_flow_types_tree_data() {
        return [
          {
            name: '现金流科目设置',
            expand: true,
            render: (h, {root, node, data}) => {
              return h('span', {
                style: {
                  display: 'inline-block',
                  width: '100%',
                }
              }, [
                h('span', {
                  style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                  }
                }, data.name),
                h('span', {
                  style: {
                    display: 'inline-block',
                    float: 'right',
                    marginRight: '32px'
                  }
                }, [
                  h('Button', {
                    style: {
                      width: '56px',
                    },
                    props: {
                      size: 'small',
                      type: 'primary',
                      icon: 'md-add',
                    },
                    on: {
                      click: () => {
                        this.addChildCashFlowType();
                      }
                    }
                  })
                ])
              ])
            },
            cash_flow_types: this.cash_flow_types
          }
        ]
      },
    },
    watch: {
      cash_flow_types() {
        this.genExpenseHash(this.cash_flow_types);
        //this.genExpenseTrs();
      }
    },
    created() {
      this.getCashFlowTypes();
    },
    mounted() {
      //
    },
    methods: {
      getCashFlowTypes() {
        this.loading = true;
        Util.ajax.get(Util.api.get_cash_flow_types).then((response) => {
          return response.data;
        }).then((res) => {
          this.cash_flow_types = [];
          if (res.code === 1) {
            const cash_flow_types = res.data.cash_flow_types;
            this.handleCashFlowTypeData(cash_flow_types);
            this.cash_flow_types = cash_flow_types;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      handleCashFlowTypeData(cash_flow_types) {
        cash_flow_types.forEach((cash_flow_type) => {
          cash_flow_type.expand = !this.isAbandoned(cash_flow_type);
          if (cash_flow_type.cash_flow_types) {
            this.handleCashFlowTypeData(cash_flow_type.cash_flow_types);
          }
        });
      },
      isAbandoned(cash_flow_type) {
        return cash_flow_type.status === -1;
      },
      renderContent(h, { root, node, data }) {
        const is_abandoned = this.isAbandoned(data);
        const type_names = [
          h('span', {
            'class': {
              'text-delete': is_abandoned,
            }
          }, `[编码: ${data.id}] ${data.name}`)
        ];
        return h('span', {
          'class': {
            'expense-type-line': true,
          },
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, [
          h('Tooltip', {
            props: {
              placement: 'top',
              content: data.full_name
            },
            style: {
              display: 'inline-block',
              verticalAlign: 'middle',
            }
          }, type_names),
          h('span', {
            style: {
              display: 'inline-block',
              float: 'right',
              marginRight: '32px'
            }
          }, is_abandoned ? '废弃' : [
            h('Button', {
              props: {
                size: 'small',
                icon: 'md-create'
              },
              style: {
                marginRight: '8px'
              },
              on: {
                click: () => {
                  this.editCashFlowType(data);
                }
              }
            }),
            h('Button', {
              props: {
                size: 'small',
                icon: 'md-add'
              },
              on: {
                click: () => {
                  this.addChildCashFlowType(data);
                }
              }
            })
          ])
        ]);
      },
      genExpenseHash(cash_flow_types) {
        cash_flow_types.forEach((cash_flow_type) => {
          this.cash_flow_type_hash[cash_flow_type.id] = cash_flow_type;
          this.genExpenseHash(cash_flow_type.cash_flow_types);
        });
      },
      genExpenseTrs() {
        this.cash_flow_type_trs = [];
        this.tr_index = 0;
        this.walkCashFlowTypes(this.cash_flow_types);
        this.fixEmptyTd();
      },
      walkCashFlowTypes(cash_flow_types) {
        cash_flow_types.forEach((cash_flow_type, index) => {
          cash_flow_type.rowspan = this.getRowspan(cash_flow_type);
          const new_cash_flow_type = Util.clone(cash_flow_type);
          if (index > 0) {
            this.tr_index++;
          }
          let tds = this.cash_flow_type_trs[this.tr_index];
          if (!tds) {
            tds = [];
            this.cash_flow_type_trs.push(tds);
          }
          tds.push(new_cash_flow_type);
          this.walkCashFlowTypes(cash_flow_type.cash_flow_types);
        });
      },
      getRowspan(cash_flow_type) {
        if (cash_flow_type.rowspan) {
          return cash_flow_type.rowspan;
        }
        if (cash_flow_type.cash_flow_types.length === 0) {
          return 1;
        } else {
          let rowspan = 0;
          cash_flow_type.cash_flow_types.forEach((child_cash_flow_type) => {
            child_cash_flow_type.rowspan = this.getRowspan(child_cash_flow_type);
            rowspan += child_cash_flow_type.rowspan;
          });
          return rowspan;
        }
      },
      fixEmptyTd() {
        this.$nextTick(() => {
          this.cash_flow_type_trs.forEach((tds) => {
            const last_td = tds[tds.length - 1];
            if (last_td.level < this.col_len) {
              for (let i = 0; i < (this.col_len - last_td.level); i++) {
                tds.push({id: `f${this.fake_id++}`, name: ''})
              }
            }
          });
        });
      },
      getParentTypeName(parent_id) {
        const parent = this.cash_flow_type_hash[parent_id];
        if (parent) {
          return parent.full_name;
        } else {
          return '无';
        }
      },
      editCashFlowType(cash_flow_type) {
        console.log(cash_flow_type);
        this.edit_cash_flow_type = Util.clone(cash_flow_type);
        this.config.modal = true;
      },
      addChildCashFlowType(parent_cash_flow_type) {
        const new_cash_flow_type = this.$util.clone(this.new_cash_flow_type);
        if (parent_cash_flow_type) {
          new_cash_flow_type.parent_id = parent_cash_flow_type.id;
          new_cash_flow_type.level = parent_cash_flow_type.level + 1;
        } else {
          new_cash_flow_type.parent_id = 0;
          new_cash_flow_type.level = 1;
        }
        this.editCashFlowType(new_cash_flow_type);
      },
      editOk() {
        Util.ajax.post(Util.api.update_cash_flow_type, this.edit_cash_flow_type).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.config.modal = false;
            this.getCashFlowTypes();
            this.$Message.success({content: '操作成功!'});
          } else {
            this.$Modal.error({title: '提示', content: '操作失败:' + data.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.resetEditLoading();
        });
      },
      resetEditLoading() {
        this.config.loading = false;
        setTimeout(() => {
          this.config.loading = true;
        }, 500);
      }
    }
  }
</script>
